<mat-form-field floatLabel="never" class="search-form" fxFlex="1 1 100%" [ngClass.gt-sm]="{ desktop: true }">
  <input matInput maxlength="256" [value]="query" (input)="onValueChanged($event.target.value);">
  <!-- TODO: labels/placeholders are bleh to style. leaving them for now. -->
  <!-- <mat-label>{{ 'SEARCH.INPUT_SEARCH_PLACEHOLDER' | translate }}</mat-label> -->
  <mat-placeholder class="placeholder">{{ 'SEARCH.INPUT_SEARCH_PLACEHOLDER' | translate }}</mat-placeholder>
  <!-- <mat-icon svgIcon="clear"></mat-icon> -->
  <mat-icon matSuffix svgIcon="search">search</mat-icon>
  <!-- <mat-icon>search</mat-icon> -->
</mat-form-field>
